import { setElementInnerHTML, setElementOnClick } from '../ui_utils/DomUtils.ts';
import { socket } from '../EntryShared.ts';
import { UIRoomCenterSettingsSpeedView } from './UIRoomCenterSettingsSpeedView.ts';
import { PlayerEnums } from '../../../../shared/GameEnums.ts';
export class UIRoomCenterSettingsSpeedController {
    get currentSetting() {
        return this._currentSetting;
    }
    set currentSetting(value) {
        this._currentSetting = value;
        const option = this.view.speedOptions.find((o)=>o === value);
        const labelKey = option != undefined ? PlayerEnums.getSpeedSettingText(option).key : 'strings:colonistCommon.utils.bug';
        setElementInnerHTML(this.view.speedInput, {
            key: labelKey
        });
    }
    update(newRoomState) {
        this.view.updateOptions(newRoomState);
        this.currentSetting = newRoomState.gameSetting.gameSpeed;
        this.view.container.classList.toggle('selected', this.currentSetting != this.view.speedDefaultSetting);
    }
    load(roomState) {
        this.initSpeedSettings(roomState);
    }
    initSpeedSettings(roomState) {
        const { speedDivBody: footerDiv, speedRightArrow: rightArrow, speedLeftArrow: leftArrow, speedSocketCommand: socketCommand } = this.view;
        if (UIRoomCenterSettingsSpeedController.isGuest(roomState)) {
            footerDiv.className = 'option_body guest';
            rightArrow.classList.toggle('hidden', true);
            leftArrow.classList.toggle('hidden', true);
            setElementOnClick(rightArrow, ()=>undefined);
            setElementOnClick(leftArrow, ()=>undefined);
            return;
        }
        footerDiv.className = 'option_body';
        leftArrow.classList.toggle('hidden', false);
        rightArrow.classList.toggle('hidden', false);
        setElementOnClick(leftArrow, ()=>{
            const optionsArray = this.view.speedOptions;
            const currentIndex = optionsArray.findIndex((o)=>o === this.currentSetting);
            let newIndex = currentIndex - 1;
            if (newIndex < 0) newIndex = optionsArray.length - 1;
            this.currentSetting = optionsArray[newIndex];
            socketCommand(this.currentSetting);
        });
        setElementOnClick(rightArrow, ()=>{
            const optionsArray = this.view.speedOptions;
            const currentIndex = optionsArray.findIndex((o)=>o === this.currentSetting);
            let newIndex = currentIndex + 1;
            if (newIndex >= optionsArray.length) newIndex = 0;
            this.currentSetting = optionsArray[newIndex];
            socketCommand(this.currentSetting);
        });
    }
    updateInteractabilityOfElements(roomState) {
        this.load(roomState);
    }
    static isGuest(roomState) {
        return socket.controller.session.id != roomState.hostSession.userSessionId;
    }
    constructor(container){
        this.view = new UIRoomCenterSettingsSpeedView(container);
        this.currentSetting = this.view.speedDefaultSetting;
    }
}
